import React from 'react'
import PropTypes from 'prop-types'

import {Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const ItemBrand = ({brand}) => {
    const styles = useMultiStyleConfig('Cart', {brand})

    return <Text {...styles.cartItemBrandText}>{brand}</Text>
}

ItemBrand.propTypes = {
    brand: PropTypes.string
}

export default ItemBrand
